import React, { Fragment } from 'react';
import { ListItemButton, Typography, Collapse, Tooltip, InputLabel, FormControl, MenuItem, Stack, Alert, Select } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from "./Widgets/CustomToolbar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import SuccessError from "./Widgets/SuccessError";
import Paper from '@mui/material/Paper';
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import _without from "lodash/without";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import RadioGroup from '@mui/material/RadioGroup';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from "react-hook-form";
import moment from 'moment';
import { set } from 'date-fns';
import { de } from 'date-fns/locale';
//import { InputLabel } from '@mui/icons-material';

const ExternalIps = () => {
    const [editOpen, setEditOpen] = React.useState(false);
    const [commonEditOpen, setEditCommonOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deleteName, setDeleteName] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
    const [accessToken, setAccessToken] = useState();
    const [refreshGrid, setRefreshGrid] = useState(0);
    const [departmentsSelected, setDepartmentsSelected] = useState([]);
    const [riskLevel, setRiskLevel] = useState('0');
    const [entryDate, setEntryDate] = useState(null);
    const [riskText, setRiskText] = useState('');


    const HandleChange = (event) => {
        const {
            target: { value },
        } = event;
        setDepartmentsSelected(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleChipDeleteForApplicableDepts = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        // if (value === 'Other') {f
        //   setotherDepartmentsShow(false);
        // }
    };
    const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
        '&.Mui-selected, &.Mui-selected:hover': {
            color: 'white',
            backgroundColor: selectedColor,
        },
    }));
    const handleRiskLevelChange = (event, newValue) => {

        setRiskLevel(newValue);
    };
    const useAsyncLoad = (url) => {
        const [errorA, setErrorA] = useState(null);
        const [loading, setLoading] = useState(true);
        const [networks, setNetworks] = useState(null);
        const { getAccessTokenSilently } = useAuth0();

        async function GetNetworksData(url) {

            const audience = 'https://piaapplication.azurewebsites.net/';

            const accessToken = await getAccessTokenSilently({
                audience: audience,

            });


            var bearer = 'Bearer ' + accessToken;

            var networksData = await fetch(url, {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                }
            });

            var data = await networksData.json();

            data.accessToken = accessToken;
            setAccessToken(accessToken);

            return data;

        };

        var x = 1;
        async function loadData(url) {

            try {

                setErrorA(null);
                // if (x < 2) {
                setLoading(true);
                //}

                var data = await GetNetworksData(url);

                setNetworks(data);
                //console.log(data);

            } catch (e) {

                setLoading(false);
                setErrorOpen(true);
            } finally {

                setLoading(false);
            }
        }

        useEffect(() => {
            loadData(url);
            // eslint-disable-next-line
        }, [refreshGrid]);


        return [networks, errorA, loading];
    }


    const FetchExternalIps = () => {
        const [value, error, loading] = useAsyncLoad("networks/getexternalips");

        return [value, error, loading];
    }


    var returnData = FetchExternalIps();
    var commonData;
    //console.log(returnData);
    if (returnData[0] !== null) {
        var externalIpsData = returnData[0].externalIps;
        commonData = returnData[0].externalIpCommon;
    }
 
    //console.log(returnData);
    var loading = returnData[2];
    var error = returnData[1];

    const closeSuccess = () => {
        setSuccessOpen(false);
    };
    const closeError = () => {
        setErrorOpen(false);
    };

    const handleCancel = () => {
        setEditOpen(false);

    };

    const handleCommonCancel = () => {
        setEditCommonOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // const CustomDisableInputSelect = styled(Select)(() => ({
    //     ".MuiInputBase-input.Mui-disabled": {
    //       WebkitTextFillColor: "#888",
    //       color: "#888"
    //     }
    //   }));
    const IpRe = RegExp('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$');
    const validationSchema = Yup.object().shape({
        id: Yup.number()
            .required('Id is required'),
        name: Yup.string()
            .required('Host Name is required')
            .max(500, 'Host Name must not exceed 500 characters'),
        internalIp: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        externalIp: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        description: Yup.string()
            .nullable()
            //.required('Module is required')
            .max(1000, 'description must not exceed 1000 characters'),
        admin: Yup.string()
            .nullable()
            .max(500, 'Admin Description must not exceed 500 characters'),
        entryDate: Yup.date()
            .nullable(),
        
    });
    const commonSchema = Yup.object().shape({
        //common data below
        ipRangeFrom: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'IP Range From must not exceed 1000 characters'),
        ipRangeTo: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'IP Range To must not exceed 1000 characters'),
        subnetMask: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'Subnet Mask must not exceed 1000 characters'),
        defaultGateway: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'Default Gateway must not exceed 1000 characters'),
        firewallAddress: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'Firewall Address must not exceed 1000 characters'),
    });

    const runValidations = () => {
        //debugger;
        validationSchema
            .validate(returnData[0].applications[2], { abortEarly: false })
            .then((responseData) => {
                console.log("no validation errors");
                console.log(responseData);
                console.log(errors);
                //setCurrentErrors([]);
            })
            .catch((err) => {
                console.log(err);
                console.log(err.name); // ValidationError
                console.log(err.errors);
                //setCurrentErrors(err.errors);
            });
    };

    const {
        register,
        control,
        setValue,
        handleSubmit: handleSubmitExternalIps,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const {
        register: registerCommon,
        controlCommon,
        setValue: setValueCommon,
        handleSubmit: handleSubmitCommon,
        clearErrorsCommon,
        formState: { errors: errorsCommon }
    } = useForm({
        resolver: yupResolver(commonSchema)
    });
    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        setTimeout(() => setSuccessOpen(false), 3000);
    };

    const showError = message => {
        setErrorOpen(true);
        setErrorMessage(message);
        setTimeout(() => setErrorOpen(false), 3000);
    };
    async function saveExternalIp(data, saveOrAddOrDelete, accessToken) {

        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'networks/saveExternalIp';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'networks/saveExternalIp';
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'networks/saveExternalIp?id=' + data.id;
        }

        var bearer = 'Bearer ' + accessToken;

        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving External IP");
            } else if (result.status === 404) {
                showError("Error saving External IP");
            }

            else {
                switch (saveOrAddOrDelete) {
                    case 'Save':
                        showSuccess("Update Successful");
                        break;
                    case 'Add':
                        showSuccess("New record added successfully");
                        break;
                    case 'Delete':
                        showSuccess("Record Deleted");
                        break;
                    default:
                        showSuccess("Update Successful");

                }

            }
        } catch (e) {

            showError();
        } finally {
            setRefreshGrid(refreshGrid + 1);
            //reRender = reRender + 1;
            //console.log(reRender);
        }
    }
    async function saveCommonData(data, accessToken) {

        var method = '';
        var url = ''
        method = 'PUT';
        url = 'networks/saveCommonData';
        var bearer = 'Bearer ' + accessToken;
        data.ipRange = data.ipRangeFrom + ' - ' + data.ipRangeTo;
        data.firewallIp = data.firewallAddress;
        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving Common Data");
            } else if (result.status === 404) {
                showError("Error saving Common Data");
            }

            else {

                showSuccess("Update Successful");

            }


        } catch (e) {

            showError();
        } finally {
            setRefreshGrid(refreshGrid + 1);
            //reRender = reRender + 1;
            //console.log(reRender);
        }
    }
    const onSubmit = data => {
        //debugger;
        //runValidations();

        if (data.id === -1) {
            saveExternalIp(data, 'Add', accessToken);
        } else {
            saveExternalIp(data, 'Save', accessToken);
        }
        setEditOpen(false);
    };

    const onSubmitCommon = data => {
        
        //runValidations();
        //save here
        saveCommonData(data, accessToken);
        setEditCommonOpen(false);
        return;

    };
    //grid columns
    const columns = [
        {
            field: "Actions", width: 150, sortable: false,
            disableExport: 'true',
            renderCell: (cellValues) => {
                return (

                    <div>
                        {/* {vendorData.userAndTenant.isSuperAdmin && */}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues, externalIpsData.accessToken);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/* } */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleDeleteOpen(event, cellValues);
                            }}
                        >
                            <DeleteIcon />
                        </Button>

                    </div>
                );
            }
        },
        {
            field: 'name', headerName: 'Name', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.name);

            }
        },
        // { field: 'phone', headerName: 'Phone', width: 130 },
        {
            field: 'internalIp', headerName: 'Internal IP', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.internalIp);

            }
        },
        {
            field: 'externalIp', headerName: 'External IP', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.externalIp);

            }
        },
        {
            field: 'description', headerName: 'Description', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.description);

            }
        },
        {
            field: 'admin', headerName: 'Admin', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.admin);

            }
        },

        {
            field: 'entryDate', headerName: 'Date', minWidth: 190, flex: 1,
            valueFormatter: (params) => params.value ? moment(params?.value).format("DD/MM/YYYY") : ''

        },

    ];

    const handleClickOpen = (event, cellValues, accessToken) => {

        var dataRow = cellValues.row;
        setValue("id", dataRow.id);
        //setDataId(dataRow.id);
        // //setAccessToken(vendorData.accessToken);
        // setValue("accessToken", accessToken);

        if (dataRow.id > 0) {
            setEditOrAddTitle('Edit');
            setValue("name", dataRow.name);
            setValue("internalIp", dataRow.internalIp);
            setValue("externalIp", dataRow.externalIp);
            setValue("description", dataRow.description);
            setValue("admin", dataRow.admin);
            setValue("entryDate", dataRow.entryDate);
            setEntryDate(dataRow.entryDate);

            setValue("deviceTypeId", dataRow.deviceTypeId);
        }
        else {
            setEditOrAddTitle('Add');
            //set the default values
            setValue("hostname", '');
            setValue("access", '');
            setValue("authenticationDesc", '');
            setValue("funcionalPurpose", '');
            setValue("ips", '');
            setValue("vlan", '');
            setValue("manufacturer", '');
            setValue("model", '');
            setValue("serialNo", '');
            setValue("vendorInfo", '');
            setValue("url", '');
            setValue("eolDate", null);
            setValue("ports", '');
            setValue("cpu", '');
            setValue("avversioning", '');
            setValue("edr", '');
            setValue("operatingSystem", '');
            setValue("physicalLocation", '');
            setValue("memory", '');
            setValue("storageSize", '');
            setValue("warrantyInfo", '');
            setValue("backupDesc", '');
            setValue("riskLevel", 0);
            setValue("comments", '');
            setRiskLevel(0);
            setValue("deviceTypeId", 0);

        }

        // setValue("tenantPiaId", dataRow.tenantPiaId);

        clearErrors();
        //setRiskLevel(dataRow.riskLevel);
        //debugger;
        //setDepartmentsSelected(dataRow.selectedDepartments);
        setEditOpen(true);
        // FetchRequests(dataRow.id, accessToken).then((requestData) => {

        //   setCurrentVendorRequests(requestData);
        // });
    };
    const handleDeleteOpen = (event, cellValues) => {
        var dataRow = cellValues.row;
        setDeleteName(dataRow.name);
        setDeleteId(dataRow.id)
        setDeleteOpen(true);
    };

    const handleDelete = () => {
        var data = { id: deleteId };
        // data.id = deleteId;
        //saveVendor(data, 'Delete');
        saveExternalIp(data, 'Delete', accessToken);
        //reRender = reRender + 1;
        setDeleteOpen(false);
    };
    const addExternalIp = (event, cellValues) => {

        setEditOrAddTitle('Add');
       
        //set the default values
        setValue("name", '');
        setValue("internalIp", '');
        setValue("externalIp", '');
        setValue("description", '');
        setValue("admin", '');
        setValue("entryDate", null);
        setValue("id", -1);


        setEntryDate(null);
        clearErrors();
        setEditOpen(true);
    };

    const editCommonData = (event, cellValues) => {

        // setEditOrAddTitle('Add');
        setEditOrAddTitle('Edit');
        if (commonData.ipRange != null) {
            var fromIp = commonData.ipRange.split(' - ')[0];
            var toIp = commonData.ipRange.split(' - ')[1];
        }
        setValueCommon("ipRangeFrom", fromIp);
        setValueCommon("ipRangeTo", toIp);
        setValueCommon("subnetMask", commonData.subnetMask);
        setValueCommon("defaultGateway", commonData.defaultGateway);
        setValueCommon("firewallAddress", commonData.firewallIp);

        // setValue("access", '');
        // setValue("authenticationDesc", '');
        // setValue("funcionalPurpose", '');
        // setValue("ips", '');
        // setValue("vlan", '');
        // setValue("manufacturer", '');
        // setValue("model", '');
        // setValue("serialNo", '');
        // setValue("vendorInfo", '');
        // setValue("url", '');
        // setValue("eolDate", null);
        // setValue("ports", '');
        // setValue("cpu", '');
        // setValue("avversioning", '');
        // setValue("edr", '');
        // setValue("operatingSystem", '');
        // setValue("physicalLocation", '');
        // setValue("memory", '');
        // setValue("storageSize", '');
        // setValue("warrantyInfo", '');
        // setValue("backupDesc", '');
        // setValue("riskLevel", 0);
        // setValue("comments", '');
        // setRiskLevel(0);
        // setValue("deviceTypeId", 0);
        // setEolDate(null);
        clearErrors();
        setEditCommonOpen(true);

    };
    const titleBoxBackgroundColour = '#1976d21a';
    const handleRiskText = function (newValue) {

        setRiskText(newValue);
    };

    if (loading) {
        return (
            // <div>
            //   Loading...
            // </div>

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }
    return (

        <div>
            <SuccessError
                successMessage={successMessage}
                errorMessage={errorMessage}
                closeError={() => closeError()}
                closeSuccess={() => closeSuccess()}
                successOpen={successOpen}
                errorOpen={errorOpen}
            >
            </SuccessError>

            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h3" component="h2">
                    External IPs
                </Typography>


                <Button variant="outlined" onClick={addExternalIp}>Add an External IP</Button>
            </Box>
            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >

                <Typography variant="h5" component="h4">
                    Common Data <Button variant="outlined" onClick={editCommonData}>Edit</Button>
                </Typography>



            </Box>
            <div style={{ height: '8vh', width: '100%', paddingLeft: '10px' }}>
                <InputLabel> IP Range: {commonData.ipRange} &nbsp;&nbsp;&nbsp; Subnet Mask: {commonData.subnetMask}</InputLabel>
                <InputLabel> Default Gateway: {commonData.defaultGateway} &nbsp;&nbsp;&nbsp; Firewall Address: {commonData.firewallIp}</InputLabel>

            </div>

            <div style={{ height: '70vh', width: '100%' }}>
                <DataGrid

                    fullWidth

                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    initialState={{
                        pagination: {
                            pageSize: 1000,
                        },
                    }}
                    height='100%'
                    rows={externalIpsData}
                    columns={columns}
                    //pageSize={100}
                    rowsPerPageOptions={[50, 100]}
                //checkboxSelection
                />

            </div>
            <Dialog open={editOpen} onClose={handleCancel} fullWidth maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}
            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} External IP
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                </DialogTitle>

                <form>
                    <DialogContent>

                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            External IP Information
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="id"
                                                    name="id"
                                                    label="ID"
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...register('id')}

                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Name"
                                                    id="name"
                                                    name="name"
                                                    label="Name"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('name')}
                                                    error={errors.name ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.name?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Internal IP"
                                                    id="internalIp"
                                                    name="internalIp"
                                                    label="Internal IP"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('internalIp')}
                                                    error={errors.internalIp ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.internalIp?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="External IP"
                                                    id="externalIp"
                                                    name="externalIp"
                                                    label="External IP"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('externalIp')}
                                                    error={errors.externalIp ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.internalIp?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8} sm={8}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Description"
                                                    id="description"
                                                    name="description"
                                                    label="Description"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('description')}
                                                    error={errors.description ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.description?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8} sm={8}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Administrator"
                                                    id="admin"
                                                    name="admin"
                                                    label="Administrator"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...register('admin')}
                                                    error={errors.admin ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.admin?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} >
                                            </Grid>

                                            <Grid item xs={3} >
                                                {/* <FormControl sx={{ m: 0, width: 190 }}> */}
                                                {/* <InputLabel> Approved By </InputLabel> */}
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        id="entryDate"
                                                        name="entryDate"
                                                        label="Date"
                                                        {...register('entryDate')}
                                                        value={entryDate}
                                                        onChange={(newValue) => {
                                                            setEntryDate(newValue);
                                                            setValue("entryDate", newValue);
                                                        }}
                                                        renderInput={(params) => <TextField  {...params} />}
                                                    />

                                                </LocalizationProvider>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.entryDate?.message}
                                                </Typography>
                                                {/* </FormControl> */}
                                            </Grid>



                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </DialogContent>

                    <DialogActions>

                        <Button color="primary" onClick={handleSubmitExternalIps(onSubmit)}>Save</Button>

                        <Button onClick={handleCancel}>Cancel</Button>

                    </DialogActions>
                </form>

            </Dialog>


            <Dialog open={commonEditOpen} onClose={handleCommonCancel} fullWidth maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}
            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} Common Data
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                </DialogTitle>

                <form>
                    <DialogContent>

                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            Common Data
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="editCommon"
                                                    name="editCommon"
                                                    value={1}
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...register('id')}

                                                />

                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='From IP'
                                                    id="ipRangeFrom"
                                                    name="ipRangeFrom"
                                                    label="IP Range From"
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerCommon('ipRangeFrom')}
                                                    error={errorsCommon.ipRangeFrom ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsCommon.ipRangeFrom?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='To IP'
                                                    id="ipRangeTo"
                                                    name="ipRangeTo"
                                                    label="IP Range To"
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerCommon('ipRangeTo')}
                                                    error={errorsCommon.ipRangeTo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsCommon.ipRangeTo?.message}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={4} sm={4}>
                                            </Grid>

                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Subnet Mask"
                                                    id="subnetMask"
                                                    name="subnetMask"
                                                    label="Subnet Mask"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerCommon('subnetMask')}
                                                    error={errorsCommon.subnetMask ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsCommon.subnetMask?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Default Gateway"
                                                    id="defaultGateway"
                                                    name="defaultGateway"
                                                    label="Default Gateway"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerCommon('defaultGateway')}
                                                    error={errorsCommon.defaultGateway ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsCommon.defaultGateway?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Firewall Address"
                                                    id="firewallAddress"
                                                    name="firewallAddress"
                                                    label="Firewall Address"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerCommon('firewallAddress')}
                                                    error={errorsCommon.firewallAddress ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsCommon.firewallAddress?.message}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </DialogContent>

                    <DialogActions>

                        <Button color="primary" onClick={handleSubmitCommon(onSubmitCommon)}>Save</Button>

                        <Button onClick={handleCommonCancel}>Cancel</Button>

                    </DialogActions>
                </form>

            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete External IP</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you wish to Delete <strong>{deleteName} ?</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleDelete}>Delete</Button>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ExternalIps;